import { DEFAULT_FASTING_GOAL_HOURS } from './intermittentFasting';

const STORAGE_KEY_PREFIX = 'mealpai_fasting_goal_hours';

export function getSavedFastingGoalHours(userId: string): number {
    try {
        const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}_${userId}`);
        if (raw) {
            const hours = Number(raw);
            if (Number.isFinite(hours) && hours >= 1 && hours <= 48) {
                return hours;
            }
        }
    } catch {
        // localStorage unavailable
    }
    return DEFAULT_FASTING_GOAL_HOURS;
}

export function saveFastingGoalHours(userId: string, hours: number): void {
    const clamped = Math.max(1, Math.min(48, hours));
    try {
        localStorage.setItem(`${STORAGE_KEY_PREFIX}_${userId}`, String(clamped));
    } catch {
        // localStorage unavailable
    }
}
